module.exports = __webpack_public_path__ + "assets/img/inform.b3142f75.svg";